import React from "react";
import AddRoles from "./AddRoles";

const Role = () => {
  return (
    <div className="px-4 py-4">
      <AddRoles />
    </div>
  );
};

export default Role;
